import { render } from "./MainMenu.vue?vue&type=template&id=dc671b2c"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=dc671b2c&lang=scss"
script.render = render

export default script